import React, { useEffect, useRef } from "react";

import { getBPMSExternalLoginPuntual } from "../../services/benefits";
import { useParams } from "react-router-dom";
import { getAfiliado } from "../../services/profile";
import { useAPIs } from "../../apis/APIsConfig";
import { getObtenerValorPorCodigo } from "../../services/parameters";
import Constants from "../../utils/constants";

export function BpmsTask() {
    useAPIs();
    const params = useParams();
    const code = params.code;
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current && code) {
            initialized.current = true
            getObtenerValorPorCodigo(Constants.ACTIVAR_BPMS_BENEFICIO)
                .then((ans) => {
                    if (ans && ans.data.successed && ans.data.value.estado == true) {

                        getAfiliado().then((res) => {
                            if (res && res.data.successed) {
                                const afiliado = { ...res.data.value };

                                getBPMSExternalLoginPuntual(code,
                                    afiliado.numeroIdentificacion).then((resp) => {
                                        if (resp && resp.data.successed) {
                                            if (localStorage.getItem(Constants.BPMS_TASKS))
                                                localStorage.removeItem(Constants.BPMS_TASKS)
                                            else
                                                localStorage.setItem(Constants.BPMS_TASKS, JSON.stringify(window.location.href.toLocaleLowerCase()));
                                            window.open(resp.data.value, '_self');
                                        }
                                    });
                            }
                        })

                    }
                })
        }
    }, []);

    return (
        <>

        </>
    );
}
